<template>
  <div>
    <router-link
        :to="{
          path: '/',
          query: {
            page,
            num,
            pagenews,
            numnews,
            type: 'species'
          },
         }"
      >
      <a class="backLink">Back</a>
    </router-link>
    <div class="menu" id="menu">
      <div class="content1">
        <div class="btn">
          <ul>
            <li class="black">
              <router-link to="/">Home</router-link>
            </li>
            <li class="ww">|</li>
            <li>
              <router-link
                :to="{
                  path: '/speciesblast',
                  query: { url: url, blastPort: blastPort },
                }"
              >Blast</router-link>
            </li>
            <li class="ww">|</li>
            <li>
              <router-link to="/primer">Primer design</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="top">
        <div class="title">
          <!-- <span>{{plant_name}}基因组数据库</span>
        <i>
          <span class="mglm" v-html="latin_name"></span>
          </i>-->
          <span v-html="tableData.mainDes"></span>
        </div>
        <div class="blast">
          <!-- <el-button size="mini" round>
            <router-link
              :to="{
                path: '/speciesblast',
                query: { url: url, blastPort: blastPort },
              }"
              >BLAST</router-link
            >
          </el-button>-->
        </div>
      </div>
      <div class="center">
        <!-- <div class="mb" v-html="tableData.mainDes"></div> -->
        <el-image v-if="cover_url" class="center1" :src="cover_url" fit="contain" />
        <el-image v-if="cover_url" class="center2" :src="cover_url" />
        <!-- <div class="search">
          <el-input
            v-model="searchGeneValue"
            placeholder="Gene ID/Name/Function"
            class="input-with-select"
          >
            <el-button @click="searchGene" class="mysearch" slot="append">
              Search
            </el-button>
          </el-input>
        </div>-->
      </div>
      <div class="bottom">
        <!-- <div class="bottom_title">
          <span class="el-icon-document"></span> Database Introduction
        </div>-->
        <div class="box">
          <span class="otitle" v-html="plant_name" style="color: seagreen"></span>
          <!-- <span class="otitle" v-html="tableData.mainDes" style="color: seagreen"></span> -->
          <!-- <div class="title"> <span>{{plant_name}}基因组数据库</span>
        <i>
          <span class="mglm" v-html="latin_name"></span>
          </i> </div>-->
          <div class="msg" v-html="tableData.plantDes"></div>
        </div>
        <div class="box">
          <div class="title">Genomic features</div>
          <table cellpadding="0" cellspacing="0">
            <tr>
              <th>Ploidy and karyotype</th>
              <th>Sequencing technology</th>
              <th>Genome size</th>
              <th>Assembly indicators</th>
              <th
                v-if="
                  genomeCharacteristic
                    ? genomeCharacteristic.gc
                      ? true
                      : false
                    : false
                "
              >GC %</th>
              <th>Number of genes</th>
            </tr>
            <tr>
              <td
                v-html="
                  genomeCharacteristic
                    ? genomeCharacteristic.ploidyKaryotype
                    : ''
                "
              ></td>
              <td
                v-html="
                  tableData.genomeCharacteristic
                    ? tableData.genomeCharacteristic.sequencePlatform
                    : ''
                "
              >Illumina\ 10X Genomics\ PacBio\ Oxford Nanopore</td>
              <td v-html="genomeCharacteristic ? genomeCharacteristic.size : ''">2.72 Gb</td>
              <td
                v-html="
                  genomeCharacteristic ? genomeCharacteristic.assemblyIndex : ''
                "
              >contig N50：1.77Mb;scaffold N50：204Mb</td>
              <td
                v-if="
                  genomeCharacteristic
                    ? genomeCharacteristic.gc
                      ? true
                      : false
                    : false
                "
                v-html="genomeCharacteristic ? genomeCharacteristic.gc : ''"
              >30.5%</td>
              <td
                v-html="
                  genomeCharacteristic ? genomeCharacteristic.geneNumber : ''
                "
              >51,213</td>
            </tr>
          </table>
          <!-- <div class="msg" v-html="tableData.genomeDes"></div> -->
        </div>
        <div class="box">
          <div class="title" @click="dialogVisible = false">Tools</div>
          <div class="ctrl">
            <el-image v-if="cover_url" class="ctrl_bg" :src="cover_url" />
            <div
              v-if="!dialogVisible"
              class="item"
              @click="dialogVisible = true"
            >Genome function search</div>
            <div v-if="!dialogVisible" class="item">
              <router-link
                target="_blank"
                :to="{
                  path: '/speciesblast',
                  query: {
                    id: id,
                    did: did,
                    latin_name: latin_name,
                    plant_name: plant_name,
                    cover_url: cover_url,
                    url: url,
                    blastPort: blastPort },
                }"
              >BLAST</router-link>
            </div>
            <div v-if="!dialogVisible" class="item">
              <!-- <a target="_blank" :href="'http://219.140.148.98:37880/'+version+'&otherUrl=&tracks=DNA,' + version + ',GCContent,GCContentXY,repeat dna,repeat line,repeat ltrc,repeat ltrg,repeat ltro,repeat sine,repeat tr&highlight='">Jbrowse</a>  -->
              <a
                target="_blank"
                v-if="jbrowse_show"
                :href="
                  'http://101.201.181.152:7322/index.html?data=data/json/' +
                  jbrowse
                "
              >Jbrowse</a>
              <a target="_blank" v-if="jbrowse_show == false" @click="hideJbrowse">Jbrowse</a>
            </div>
            <div v-if="!dialogVisible" class="item">
              <router-link
                      target="_blank"
                      :to="{
                  path: '/primer',
                  query: {
                    id: id,
                    did: did,
                    latin_name: latin_name,
                    plant_name: plant_name,
                    cover_url: cover_url}
                }"
              >Primer design</router-link>
            </div>
            <div class="search" v-if="dialogVisible">
              <div class="bg">
				  <span @click="dialogVisible = false"><</span>
			  </div>
              <el-input
                v-model="searchGeneValue"
                placeholder="Genome function search"
                class="input-with-select"
              >
                <el-button @click.stop="searchGene" class="mysearch" slot="append">Search</el-button>
              </el-input>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="title">Natural product</div>
          <table cellpadding="0" cellspacing="0">
            <tr>
              <th>Chinese name</th>
              <th>Structure</th>
              <th>Name</th>
              <th>Formula</th>
              <th>CAS accession number</th>
              <th
                v-if="
                  metaboliteList[0]
                    ? metaboliteList[0].kegg
                      ? true
                      : false
                    : false
                "
              >KEGG entry number</th>
            </tr>
            <tr v-for="(item, index) in metaboliteList" :key="index">
              <td v-html="item.chineseName">吗啡</td>
              <td>
                <el-popover placement="right" width="400" trigger="hover">
                  <img :src="item.structuralFormula" width="400" height="400" />
                  <img slot="reference" :src="item.structuralFormula" />
                </el-popover>
              </td>
              <td v-html="item.englishName">D-(-)-Morphine</td>
              <td v-html="item.molecularFormula">C17H19NO3</td>
              <td v-html="item.cas">57-27-2</td>
              <td v-if="item.kegg">
                <a :href="item.keggLink" target="_blank">{{ item.kegg }}</a>
              </td>
              <!-- <td v-if="!item.kegg">
             -
              </td>-->
            </tr>
          </table>
          <!-- <div class="msg" v-html="tableData.metaboliteDes"></div> -->
        </div>
        <div class="box">
          <div class="title">Download</div>
          <table cellpadding="0" cellspacing="0">
            <tr>
              <th>Version</th>
              <th>Genome</th>
              <th>GFF</th>
              <th>CDS</th>
              <th>Protein</th>
              <th>Annoation*</th>
            </tr>
            <tr v-for="(item, index) in downloadsList" :key="index">
              <td>
                <a v-html="item.version"></a>
              </td>
              <td>
                <a @click="downliadfile(item.genome)" href="javascript:void(0)" v-if="item.genome">
                  <i class="el-icon-download"></i>
                </a>
                <span v-else>-</span>
              </td>
              <td>
                <a @click="downliadfile(item.gff)" href="javascript:void(0)" v-if="item.gff">
                  <i class="el-icon-download"></i>
                </a>
                  <span v-else>-</span>
              </td>
              <td>
                <a @click="downliadfile(item.cds)" href="javascript:void(0)" v-if="item.cds">
                  <i class="el-icon-download"></i>
                </a>
                  <span v-else>-</span>
              </td>
              <td>
                <a @click="downliadfile(item.protein)" href="javascript:void(0)" v-if="item.protein">
                  <i class="el-icon-download"></i>
                </a>
                  <span v-else>-</span>
              </td>
              <td>
                <a @click="downliadfile(item.annoation)" href="javascript:void(0)" v-if="item.annoation">
                  <i class="el-icon-download"></i>
                </a>
                  <span v-else>-</span>
              </td>
            </tr>
            <tr v-if="downloadsList.length < 1">
              <td colspan="6">no data</td>
            </tr>
          </table>
          <div class="msg" style="margin: 10px 0 0 0">* Annotated version of the Benagen</div>
          <!-- <div class="msg" v-html="tableData.dateDownload"></div> -->
        </div>
        <div class="box">
          <div class="title">Reference</div>
          <div class="msg" v-html="tableData.pubLink"></div>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios"

var path = require("path")
var proEnv = require("../../../config/pro.env") //生产环境
var uatEnv = require("../../../config/uat.env") //测试环境
var devEnv = require("../../../config/dev.env") //本地环境
export default {
  data() {
    return {
      userId: '',
      tableData: "",
      latin_name: "",
      plant_name: "",
      cover_url: '',
      searchGeneValue: "",
      version: "",
      blastPort: "",
      jbrowse:"",
      id:'',
      url: "",
      title: "",
      did: "",
      metaboliteList: [],
      downloadsList: [],
      genomeCharacteristic: {
        assemblyIndex: "",
        gc: "",
        geneNumber: "",
        genomeid: "",
        id: "",
        ploidyKaryotype: "",
        sequencePlatform: "",
        size: "",
      },
      dialogVisible: false,
      jbrowse_show: false,
      downloadPermissions: false,
      page : 1,
      num:5
    }
  },
  created() {

    window.addEventListener("scroll", this.handleScroll)
    let token = localStorage.getItem("authorization")
    let moduleAuthorityList = JSON.parse(
      localStorage.getItem("moduleAuthorityList")
    )
    if (token == "" || token == null) {
      this.$alert("Please login first", "Notice", {
        confirmButtonText: "Confirm",
        callback: (action) => {
          that.$router.push("/login")
        },
      })
      return false
    }
    if (moduleAuthorityList) {
      //primer3使用
      let jbrowse_use = moduleAuthorityList.find(
        (item) => item.moduleName == "jbrowse" && item.moduleAuthority == "use"
      )
      if (jbrowse_use != null) {
        if (jbrowse_use.moduleAuthority == "use") {
          //console.log(jbrowse_use);
          this.jbrowse_show = true
        } else {
          this.jbrowse_show = false
        }
      } else {
        this.jbrowse_show = false
      }
    }
    //console.log(this.$route.query.did);
    this.page = this.$route.query.page
    this.num = this.$route.query.num
    this.pagenews = this.$route.query.pagenews
    this.numnews = this.$route.query.numnews
    let did = this.$route.query.did
    let id = this.$route.query.id
    let latin_name = this.$route.query.latin_name
    let plant_name = this.$route.query.plant_name
    let cover_url = this.$route.query.cover_url
    if (did == "" || id == "") {
      this.$router.push("/")
    } else {
      this.id = id
      this.latin_name = latin_name
      this.plant_name = plant_name
      this.cover_url = cover_url
      this.did = did
      this.getbyid(did)
      this.genomeInfoId(id)
    }

    //console.log(process.env.NODE_ENV);
    const env = process.env.NODE_ENV
    let target = ""
    //默认是本地环境
    if (env === "production") {
      //生产环境
      target = proEnv.blasturl
    } else if (env === "test") {
      //测试环境
      target = uatEnv.blasturl
    } else {
      //本地环境
      target = devEnv.blasturl
    }
    this.url = target

    // 验证下载权限
    this.userId = localStorage.getItem("userId")
    this.checkDownload(this.userId)

	document.backUrl = '/'
	document.backParam = {}
  },
  methods: {
    downliadfile(str) {
      console.log(str)
      if (this.downloadPermissions) {
        console.log(this.downloadPermissions)

        if ("download" in document.createElement("a")) {
          //非IE下载
          let elink = document.createElement("a") // 创建一个<a>标签
          elink.style.display = "none" // 隐藏标签
          elink.href = 'http://101.201.181.152' + str // 配置href
          elink.download = str
          console.log(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink) // 移除<a>标签
        } else {
          //IE10+
          navigator.msSaveBlob(blob, str)
        }


        ////console.log(str);
        // let token = localStorage.getItem("authorization")
        // axios
        //   .get("/bena/server/file?filename=" + str, {
        //     headers: { Authorization: token },
        //     responseType: 'blob'
        //   })
        //   .then(function (response) {
        //     console.log(response)
        //     var zipName = str // 下载的文件名
        //     let blob = new Blob([response.data], { type: "application/zip" }) // 下载格式为zip
        //     if ("download" in document.createElement("a")) {
        //       //非IE下载
        //       let elink = document.createElement("a") // 创建一个<a>标签
        //       elink.style.display = "none" // 隐藏标签
        //       elink.href = window.URL.createObjectURL(blob) // 配置href
        //       elink.download = zipName
        //       //console.log(elink)
        //       elink.click()
        //       URL.revokeObjectURL(elink.href) // 释放URL 对象
        //       document.body.removeChild(elink) // 移除<a>标签
        //     } else {
        //       //IE10+
        //       navigator.msSaveBlob(blob, zipName)
        //     }
        //   })
        //   .catch(function (error) {
        //     console.log('未获取到文件' + str)
        //   })
      }
      else {
        this.$alert("您没有此权限，请联系我们：027-62435310", "Notice", {
          confirmButtonText: 'Confirm',
          callback: (action) => {
            return false
          },
        })
      }
    },
    hideJbrowse() {
      this.$alert("Loading failed！Permission Denied！", "Notice", {
        confirmButtonText: "Confirm",
        callback: (action) => {
          return false
        },
      })
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let offsetTop = document.querySelector("#menu").offsetTop
      let isFixed = scrollTop > offsetTop ? true : false
      if (isFixed) {
        document.querySelector("#menu").style =
          "position: fixed;top:0;background:#fff;z-index:9999"
      } else {
        document.querySelector("#menu").style = ""
      }
    },
    hidesearch() {
      this.dialogVisible = false
    },
    returnEvent() {
      //console.log(1);
      return false
    },
    searchGene() {
      if (this.searchGeneValue == "" || this.searchGeneValue == null) {
        this.$alert("请输入GeneID/Name/Function！", "Notice", {
          confirmButtonText: 'Confirm',
          callback: (action) => {
          },
        })
      }
      // else if (this.version == null || this.version == "") {
      //   this.$alert("没有权限！", "Notice", {
      //     confirmButtonText: 'Confirm',
      //     callback: (action) => {
      //     },
      //   });
      // } 
      else {
        ////console.log(this.version);
        // //console.log(this.url);
        // //console.log(this.did);
        this.$router.push(
          "/search?value=" +
          this.searchGeneValue +
          "&version=" +
          this.version +
          "&did=" +
          this.did +
          "&url=" +
          this.url +
          "&blastPort=" +
          this.blastPort +
          "&plant_name=" +
          this.plant_name
        )
      }
    },
    getbyid(did) {
      let that = this
      let token = localStorage.getItem("authorization")
      axios
        .get("/bena/server/gooal/description/getbyid?id=" + did, {
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            that.tableData = response.data.result
            that.metaboliteList = response.data.result.metaboliteList
            that.genomeCharacteristic =
              response.data.result.genomeCharacteristic
            that.title = response.data.result.mainDes
            that.downloadsList = response.data.result.downloadsList
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                return false
              },
            })
          }
        })
        .catch(function (error) {
          that.$alert("Loading failed！" + error.response.data.message, "Notice", {
            confirmButtonText: 'Confirm',
            callback: (action) => {
              return false
            },
          })
          //that.$message.error("失败!");
          //console.log(error);
          return false
        })
    },
    genomeInfoId(id) {
      let that = this
      let token = localStorage.getItem("authorization")
      axios
        .get("/bena/server/gooal/genome/version/" + id, {
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            that.version = response.data.result.versionList[0]
            that.blastPort = response.data.result.blastPort
			that.jbrowse = response.data.result.jbrowse
          } else {
            that.$alert("等待开发中！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                that.$router.push("/")
              },
            })
          }
        })
        .catch(function (error) {
          // that.$alert("Loading failed！" + error.response.data.message, "Notice", {
          //   confirmButtonText: 'Confirm',
          //   callback: (action) => {
          //      return false;
          //   },
          // });
          //that.$message.error("失败!");
          //console.log(error);
          return false
        })
    },
    checkDownload(userId) {
      let that = this
      let token = localStorage.getItem("authorization")
      axios
        .get("/bena/server/gooal/genome/downrole?user_id=" + userId, {
          headers: { Authorization: token },
        })
        .then(function (response) {
          that.downloadPermissions = false
          let result = response.data
          result.forEach(item => {
            if (item.id == that.$route.query.id) {
              that.downloadPermissions = true
            }
          })
        })
        .catch(function (error) {
          console.log(error)
          return false
        })
    }
  },
};
</script>
<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}

.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}

.menu .black {
  color: #000;
}

.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}

.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}

.menu .content1 .btn {
  /* float: right; */
  width: auto;
}

.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}

.menu .content1 .btn ul li.ww {
  color: #ccc;
}

.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}

.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}

.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}

.content {
  width: 1200px;
  height: auto;
  margin: 0 auto 20px auto;
  /* border: 1px solid #eee; */
  box-shadow: 0 0 12px #ccc;
  background: #fff;
}

.top {
  width: 1140px;
  height: 80px;
  line-height: 80px;
  padding: 0 30px;
  display: flex;
}

.top .title {
  flex: 1;
  color: seagreen;
  font-weight: normal;
}

.top .blast {
  width: 100px;
}

.top .blast .el-button.el-button--default.el-button--mini.is-round {
  background: seagreen;
  color: #fff;
}

.top .blast a {
  color: #fff;
  text-decoration: none;
}

.mglm {
  margin-left: 40px;
}

.center {
  border: 1px solid #eee;
  box-shadow: 1px 1px 1px #eee;
  position: relative;
  overflow: hidden;
}

.center .mb {
  position: absolute;
  top: 200px;
  left: 100px;
  padding: 20px;
  background: rgba(88, 88, 88, 0.7);
  font-size: 18px;
  color: white;
}

.center .center1 {
  position: absolute;
  z-index: 999;
  width: 1200px;
  height: 450px;
  /* border-radius: 8px 8px 0 0; */
}

.center .center2 {
  filter: blur(20px);
  width: 1200px;
  height: 450px;
  /* border-radius: 8px 8px 0 0; */
}

.center .search {
  width: 800px;
  height: 40px;
  /* border: 1px solid red; */
  padding: 20px 200px;
  background: #e3f3ea;
}

.input-with-select.el-input >>> .el-input-group__append,
.el-input-group__prepend {
  border: none;
  background: none;
}

.center .search .el-button.el-button--default {
  background: seagreen;
  color: #fff;
  width: 100px;
  border-radius: 0px 20px 20px 0px;
  height: 40px;
}

.center .search >>> .el-input__inner {
  border-radius: 20px 0px 0px 20px;
}

.bottom {
  width: 1120px;
  height: auto;
  padding: 0 40px;
}

.bottom_title {
  line-height: 45px;
  font-size: 16px;
  margin-top: 20px;
  margin-left: 20px;
  font-weight: bold;
}

.bottom_title span {
  font-size: 20px;
  color: seagreen;
}

.box {
  padding: 20px 20px 0px 20px;
}

.box .otitle {
  font-weight: bold;
}

.box .title {
  width: 100%;
  color: #fff;
  line-height: 35px;
  background: seagreen;
  width: 150px;
  text-align: center;
  margin-bottom: 10px;
}

.box.bg {
  background: #eee;
}

.box .msg {
  line-height: 25px;
  font-size: 14px;
  color: #000;
}

.box .ctrl {
  /* width: 100%; */
  /* border: 1px solid red; */
  display: flex;
  /* padding: 20px 20px; */
  justify-content: space-around;
  position: relative;
}

.ctrl {
  overflow: hidden;
}

.ctrl .ctrl_bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  filter: blur(5px);
  z-index: 1;
}

.ctrl .center2 {
}

.box .search {
  width: 800px;
  height: 40px;
  /* border: 1px solid red; */
  padding: 20px 200px;
  /* background: #e3f3ea; */
  position: relative;
  z-index: 999;
}

.box .bg {
  width: 100%;
  height: 100%;
  /* background: #e3f3ea; */
  position: absolute;
  top: 0;
  left: 0;
}

.box .search .bg span{
	position: absolute;
	left: 22px;
	top: 10px;
	cursor: pointer;
}

.box .search .el-button.el-button--default {
  background: seagreen;
  color: #fff;
  width: 100px;
  border-radius: 0px 20px 20px 0px;
  height: 40px;
}

.box .search >>> .el-input__inner {
  border-radius: 20px 0px 0px 20px;
}

.box .ctrl div.item {
  width: 22%;
  /* border: 1px solid seagreen; */
  text-align: center;
  line-height: 60px;
  color: seagreen;
  font-weight: bold;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 0px 5px #666;
  z-index: 999;
  margin: 20px 0;
}

.box .ctrl div.item a {
  color: seagreen;
  font-weight: bold;
  font-size: 14px;
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}

.box .ctrl div.item:hover a {
  cursor: pointer;
  color: seagreen;
  /* background: rgb(224, 240, 247); */
}

.box .ctrl div.item:hover {
  cursor: pointer;
  color: seagreen;
  /* background: rgb(224, 240, 247); */
}

.box table {
  width: 100%;
}

.box table tr:first-child {
  background: seagreen;
  color: #fff;
}

.box table tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  line-height: 35px;
  font-size: 14px;
}
.backLink{
  position: fixed;
  top: 15px;
  left:20px;
  background-color: white;
  text-underline: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 13px;
  color: #999;
}
</style>
